import { Input } from '@seiue/ui'
import { Badge } from 'antd'
import React, { useState } from 'react'

import { DataTable, TableQuery } from 'packages/components/DataTable'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import {
  Reflection,
  ReflectionGenderEnum,
  ReflectionRoleEnum,
  ReflectionStatusEnum,
  reflectionApi,
} from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'
import { AnyValueObj } from 'packages/types'
import { genderToLabel, statusToColor, statusToLabel } from 'packages/utils'

import { formatInformStuDataSource } from '../UserManagement/utils'

import { searchParamFormat } from './utils'
import { formatPrivateInfo } from '@/features/activities/pages/Detail/ReflectionList/utils'

/**
 * 管理员（在校教师）列表
 *
 * @param param - 参数
 * @param param.selectedRowKeys - 选中的管理员ID
 * @param param.setSelectedRowKeys - 修改选中的管理员
 * @returns React.ReactNode
 */
export const AdministratorList: React.FC<{
  selectedRowKeys: number[]
  setSelectedRowKeys: (v: number[]) => void
}> = ({ selectedRowKeys, setSelectedRowKeys }) => {
  const [searchParams, setSearchParams] = useState<AnyValueObj | undefined>(
    undefined
  )
  const columns = [
    {
      title: '姓名',
      key: 'name',
      dataIndex: 'name',
      width: '20%',
    },
    {
      title: '性别',
      key: 'gender',
      dataIndex: 'gender',
      width: '10%',
      render: (gender: ReflectionGenderEnum) => {
        return genderToLabel.get(gender)
      },
    },
    {
      title: '学科',
      key: 'subject',
      dataIndex: 'subject',
      width: '15%',
    },
    {
      title: '手机号码',
      key: 'phone',
      width: '20%',
      render: (text: Reflection) => formatPrivateInfo(text.phone, false),
    },
    {
      title: '入职时间',
      key: 'admissionedAt',
      dataIndex: 'admissionedAt',
      width: '25%',
    },
    {
      title: '账号状态',
      key: 'status',
      dataIndex: 'status',
      width: '15%',
      render: (text: ReflectionStatusEnum) => {
        return (
          <Badge
            color={text ? statusToColor.get(text) : 'yellow'}
            text={text ? statusToLabel.get(text) : '-'}
          />
        )
      },
    },
  ]
  return (
    <DataTable
      columns={columns}
      api={(q: TableQuery) => {
        return reflectionApi.queryTeachers({
          ...q,
          ...searchParams,
          ...(searchParams ? { page: 1 } : undefined),
          archivedAtNotEmpty: false,
          expand: ['passwordChangeNeeded', 'fields'],
          roleIn: [ReflectionRoleEnum.Teacher, ReflectionRoleEnum.Shadow].join(
            ','
          ),
        })
      }}
      apiName="Reflection.queryTeachers"
      formatData={formatInformStuDataSource}
      extraApiDependence={[searchParams]}
      headerRight={
        <EntryComponentsWrapper>
          <Input
            style={{
              width: '400px',
            }}
            placeholder="搜索姓名/手机号，用逗号分隔进行批量搜索"
            addonAfter={<GrowpIcon name="Search" />}
            onPressEnter={(e) => {
              const v = (e.target as HTMLInputElement).value
              const params = searchParamFormat(v)
              setSearchParams(params)
            }}
          />
        </EntryComponentsWrapper>
      }
      showSelectedAll={true}
      selectedRowKeys={selectedRowKeys}
      onSelectedRowKeysChange={(keys) => setSelectedRowKeys(keys as number[])}
      isPagination={true}
      showSearchForm={false}
      scroll={{ x: '1300', y: '400px' }}
    />
  )
}
